module.exports={close:"Close",error:"Error",warning:"Warning",success:"Success",info:"Information"};